import React from "react";

// import { useNavigate } from "react-router-dom";

import LogoDog from "../../assets/images/logo-dog-register.png";
import LogoNex from "../../assets/images/logo-nex-register.png";
import DogStarHeart from "../../assets/images/cat-success-p2.png";
import LogoSpectra from "../../assets/images/logo-combo-p2.png";
import SuccessStyle from "../../assets/images/success-style.png";
import PrimaryButton from "../../components/button/PrimaryButton";
import PopupRegisterSuccess from "../../components/popup/PopupRegisterSuccess";
import { useLocation, useNavigate } from "react-router-dom";
import SecondaryButton from "../../components/button/SecondaryButton";
import { useSelector } from "react-redux";
import TopLogoCat from "../../components/layout/TopLogoCat";

export default function ConfirmCatSuccess() {
  const store = useSelector((state) => state.registerPetShop);

  const { state } = useLocation();
  //ปิด popup
  const [openCancelPopup, setOpenCancelPopup] = React.useState(false);
  const navigate = useNavigate();
  return (
    <>
      <PopupRegisterSuccess
        point={state?.point}
        actionFunction={() => {
          setOpenCancelPopup(false);
        }}
        open={openCancelPopup}
        onClose={() => {
          setOpenCancelPopup(false);
        }}
      />
      <TopLogoCat />
      <div
        style={{
          minHeight: "calc(100vh - 60px)",
          padding: "20px",
          background: "linear-gradient(129.17deg, #213468 22.83%, #213468 36.49%, #1D4164 41.4%, #15645A 50.69%, #079D4A 63.25%, #07A14A 63.8%, #07A14A 77.45%)",

        }}
      >
        <img
          src={SuccessStyle}
          alt="logo"
          style={{ width: "70%", float: "right" }}
          className="mt-[-20px] mr-[-20px]"
        />
        <div className="mt-[40px] w-full" style={{
          position: "fixed",
          left: "50%",
          transform: "translate(-50%, 0)"
        }}>
          <div className="text-white text-center text-[30px] mt-[50px]">
          ยืนยันตัวตนสำเร็จ
          </div>
          <div className="text-white text-center text-[24px]">
          ยินดีต้อนรับสู่ครอบครัว One And Done
          </div>
          <img
            className="mx-auto my-[20px]"
            src={DogStarHeart}
            alt="logo"
            style={{ width: "50%" }}
          />
          <div className="text-white text-center text-[24px]">
            สิทธิพิเศษมากมายจาก{" "}
            <img
              src={LogoSpectra}
              alt="logo"
              style={{ width: "70px", display: "inline-block" }}
            />{" "}
            รอคุณอยู่
          </div>
          <div className="text-center mt-[50px]">
            {/*btn member*/}
            {!store["isPetShop"] && (
              <div className="my-4">
                <PrimaryButton
                  variant="contained"
                  className="w-[70%] !bg-[#082e683d]"
                  onClick={() => {
                    navigate("/catbook");
                  }}
                  sx={{
                    border: "1px solid white",
                  }}
                >
                  ไปหน้าสมุดพกสัตว์เลี้ยง
                </PrimaryButton>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
